import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_BASE_URL;

const ApiBaseUrl = axios.create({
    baseURL: apiBaseUrl,
});
const token = localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).session.access_token;

ApiBaseUrl.interceptors.request.use(async config => {
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    // Tangani kesalahan permintaan
    console.log("error config:", error)
    return Promise.reject(error);
});

// Tambahkan interceptor response
ApiBaseUrl.interceptors.response.use(async response => {
        // Tanggapi respons data
        return response;
    }, error => {
        console.log("error response:", error)
        // Tangani kesalahan respons
        return Promise.reject(error);
    }
)
;
export default ApiBaseUrl;
